<template>
  <b-nav-item @click="skin = isDark ? 'light' : 'dark'">
    <feather-icon
      v-b-tooltip.hover.bottom="tooltipText"
      size="21"
      :icon="`${isDark ? 'Sun' : 'Moon'}Icon`"
    />
  </b-nav-item>
</template>

<script>
import useAppConfig from '@core/app-config/useAppConfig'
import { computed } from '@vue/composition-api'
import { BNavItem, VBTooltip } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { useUtils as useI18nUtils } from '@core/libs/i18n'

export default {
  components: {
    BNavItem,
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  setup() {
    const { skin } = useAppConfig()
    const { t } = useI18nUtils()

    const isDark = computed(() => skin.value === 'dark')
    const tooltipText = computed(() => t(isDark.value ? 'Switch to Light Mode' : 'Switch to Dark Mode'))

    return { skin, isDark, tooltipText }
  },
}
</script>
